<script>
import { mapGetters } from 'vuex';
import i18n from './i18n';
import PlayerPage from './containers/PlayerPage.vue';
import EndPage from './containers/EndPage.vue';
import Wrapper from 'ne01-common/src/components/Wrapper';
import PageHeader from './components/PageHeader.vue';
import ErrorMessage from './components/ErrorMessage.vue';
import LoadIndicator from './components/LoadIndicator.vue';

export default {
  name: 'app',
  components: {
    Wrapper,
    ErrorMessage,
    LoadIndicator,
    PageHeader,
    PlayerPage,
    EndPage
  },
  mounted() {
    if (!window.apiUrl) {
      window.apiUrl = 'https://lasauge.bird-song.ch';
    }
    if (!window.cmsUrl) {
      window.cmsUrl = 'https://wp.ls.bird-song.ch';
    }
    if (!window.cmsSlug) {
      window.cmsSlug = 'station-5';
    }

    const visitorId = new URL(window.location.href).searchParams.get('visitor') || 1;
    const lang = new URL(window.location.href).searchParams.get('lang') || 'de';

    this.$store.dispatch('initApp', { visitorId, lang });
    this.$store.dispatch('loadCmsData', lang);

    i18n.locale = lang;
  },
  methods: {
    loadCsmData() {
      this.$store.dispatch('loadCmsData');
    },
    retryLoading() {
      if (this.lastAction === 'loadCmsData')
        this.loadCmsData();
      if (this.lastAction === 'sendStatistics')
        this.unloadStation();
    },
    unloadStation() {
      if (this.hasStarted)
        this.$store.dispatch('sendStatistics', { ...this.statisticsTotals.normalized, visitor_id: this.visitorId, station_id: 5 });
      else
        window.postMessage('end');
    },
  },
  computed: {
    ...mapGetters({
      lang: 'getLang',
      loading: 'getShowLoadindicator',
      error: 'getDataLoadError',
      heading: 'getStationHeading',
      intro: 'getStationIntro',
      screenState: 'getStationScrrenState',
      introTrack: 'getStationIntroTrack',
      lastAction: 'getLastHttpAction',
      statisticsTotals: 'getStatisticsTotals',
      hasStarted: 'getHasStarted',
      visitorId: 'getVisitorId',
    })
  }
};
</script>

<template>
  <div id="app">
    <!-- <div class="wrap-disabled">
      <p>Diese Station ist deaktiviert.<br>Bitte scannen Sie einen anderen QR-Code.</p>
      <a href="#"
         @click.prevent="unloadStation">Station beenden</a>
    </div> -->

    <wrapper v-if="!loading && !error"
             v-bind:src="introTrack"
             v-bind:heading="heading"
             nr="5">
      <p slot="intro">{{intro}}</p>
      <div class="content"
           v-if="!loading && !error">
        <div class="content__inner">
          <player-page v-if="screenState === 'player'"
                       v-on:unloadStation="unloadStation"></player-page>
        </div>
      </div>
    </wrapper>

    <div class="load-indicator"
         v-if="loading">
      <load-indicator></load-indicator>
    </div>

    <error-message v-bind:error="error"
                   v-on:reloadData="retryLoading()"></error-message>

  </div>
</template>

<style lang="scss">
@import './assets/styles/fonts';
@import './assets/styles/variables';
@import './assets/styles/common';

#app {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  font-family: var(--font-family-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--dark, black);
  background: var(--color-main);
}

.content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  background-image: linear-gradient(-180deg, var(--color-main) 38%, var(--color-main--stop) 100%);
  z-index: 3;
}

.content__inner {
  flex: 1;
}

.load-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.wrap-disabled {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  padding: 2rem;
  font-weight: 400;
  text-align: center;
  box-sizing: border-box;

  a {
    display: block;
    background-color: #000;
    color: #fff;
    padding: .75rem 3rem;
    text-decoration: none;
  }
}
</style>
